import SuspendedUsersGrid from './suspended-users-grid';

export default function SuspendedUsersPage() {
  return <SuspendedUsersGrid />;
}
